enum LanguageType {
  EN = "en",
  JA = "ja",
}

interface RankingLevelsType {
  gold: number;
  silver: number;
  bronze: number;
}

enum TokenType {
  TOKEN = "token",
  COIN = "coin",
}

interface AssetTokenType {
  contract_address: string;
  name: string;
  symbol: string;
  token_type: TokenType;
  decimal: number;
  coingecko_id: string;
  image_url: string;
  is_active?: boolean;
}

interface NetworkType {
  chain_id: number;
  explorer_url: string;
  image_url: string;
  name: string;
  rpc_url: string;
  short_name: string;
  socket_url: string | null;
  symbol: string;
  is_active?: boolean;
}

interface DurationPlan {
  is_active: boolean;
  duration: number;
  en: string;
  ja: string;
}

interface MaintenanceConfig {
  title: string;
  message: string;
}

interface BasicConfig {
  disabledChatAddresses: string[];
  maxMembersGroup: number;
  maxMembersParty: number;
  maxMultiTransfer: number;
  maxPinsNFT: number;
  rankingLevels: RankingLevelsType;
  pinnedChainIds: string[];
  payToOpenAssets: Record<string, AssetTokenType[]>;
  supportNetworks: NetworkType[];
  snsDomain: string;
  partyInvitationURL: string;
  maxPinnedRooms: number;
  audienceSubscriptionNetworks: NetworkType[] | null;
  audienceSubscriptionToken: Record<string, AssetTokenType[]> | null;
  audienceSubscriptionReferralFee: number;
  audienceSubscriptionDurationPlans: DurationPlan[];
  enableAudienceSubscription: boolean | null;
  maintenance: MaintenanceConfig | null;
}

interface AudienceConfig {
  sendTextMessage: boolean;
  sendAttachmentMessage: boolean;
  sendPayment: boolean;
  sendPaymentRequest: boolean;
  sendPayToOpen: boolean;
  reactMessage: boolean;
  unSendMessage: boolean;
  deleteMessage: boolean;
}

interface AppConfig {
  basicConfig: BasicConfig;
  contracts: ContractConfig;
  audience: AudienceConfig;
}

interface ContractConfig {
  followedNTTContract: Record<string, string>;
  followingNTTContract: Record<string, string>;
  multipleTransferContract: Record<string, string>;
  nftIssueContract: Record<string, string>;
  payToOpenContract: Record<string, string>;
  socialContract: Record<string, string>;
  audienceSubscription: Record<string, string>;
}

export {
  LanguageType,
  type RankingLevelsType,
  TokenType,
  type AssetTokenType,
  type NetworkType,
  type DurationPlan,
  type MaintenanceConfig,
  type BasicConfig,
  type AudienceConfig,
  type ContractConfig,
  type AppConfig,
};
